import { SpinResponse, InternalRespinSpecGroup } from '@cgs/data-access';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from '../states/base_game_state';
import { BaseGameRule } from './infra/base_game_rule';

export class AccelerateToWaitAccelerationComplete<
  TResponse extends SpinResponse,
> extends BaseGameRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  ruleCondition(resp: ResponseHolder<TResponse>): boolean {
    const respinGroup =
      resp.curResponse.additionalData instanceof InternalRespinSpecGroup
        ? resp.curResponse.additionalData
        : null;
    return (
      !!respinGroup &&
      respinGroup.groups.length > 0 &&
      respinGroup.respinCounter < respinGroup.groups.length
    );
  }
}
